import React from 'react'
import { StyledPage } from './style'
interface PageContentProps {
  children?: React.ReactNode
  className?: string
}

const PageContent = ({ children, className }: PageContentProps) => {
  return (
    <StyledPage className={`page-content ${className ?? ''}`.trim()}>
      {children}
    </StyledPage>
  )
}

export default PageContent
